import { useState } from "react";
import { MapboxProvider } from "../../map/mapbox-provider";
import { MapToolbar } from "../../map/map-toolbar";
import { SidebarResultsRight } from "../sidebar/sidebar-results-right";
import { PropertyLayer } from "../property-layer";
import { BuildingLayer } from "../building-layer";

export const ComparisonPane = ({
  mapId,
  projectId,
  selectedRunner,
  selectedResult,
  isLeftSide,
}) => {
  const [selectedBuilding, setSelectedBuilding] = useState(null);
  const [displayDimensions, setDisplayDimensions] = useState(false);

  const [buildingGrids, setBuildingGrids] = useState({});
  const [showGrid, setShowGrid] = useState(false);

  const getSelectedGridIndex = (resultId, buildingId) =>
    buildingGrids?.[resultId]?.[buildingId] ?? 0;

  const setSelectedGridIndex = (resultId, buildingId, gridIndex) => {
    setBuildingGrids((prev) => ({
      ...prev,
      [resultId]: {
        ...prev[resultId],
        [buildingId]: gridIndex,
      },
    }));
  };

  return (
    <MapboxProvider mapId={mapId}>
      <MapToolbar
        selectedRunner={selectedRunner}
        isSiteSettings={false}
        displayDimensions={displayDimensions}
        setDisplayDimensions={setDisplayDimensions}
        property={selectedRunner.PropertyData || null}
        propertyLocation={selectedRunner?.PropertyData?.coordinates || null}
      />

      {selectedResult && (
        <SidebarResultsRight
          selectedBuilding={selectedBuilding}
          selectedResult={selectedResult}
          propertyArea={selectedRunner?.PropertyData?.area}
          isLeftSide={isLeftSide}
          surveyData={{
            resultName: selectedResult.name,
            runnerName: selectedRunner.name,
          }}
          showGrid={showGrid}
          setShowGrid={setShowGrid}
          getSelectedGridIndex={getSelectedGridIndex}
          setSelectedGridIndex={setSelectedGridIndex}
        />
      )}

      {selectedRunner?.PropertyData && (
        <PropertyLayer
          selectedRunner={selectedRunner}
          runnerPropertyData={selectedRunner?.PropertyData}
          displayDimensions={displayDimensions}
        />
      )}

      {selectedResult && (
        <BuildingLayer
          projectId={projectId}
          selectedResult={selectedResult}
          buildings={selectedResult.buildings}
          selectedBuilding={selectedBuilding}
          setSelectedBuilding={setSelectedBuilding}
          routes={selectedResult.routes}
          showGrid={showGrid}
          getSelectedGridIndex={getSelectedGridIndex}
        />
      )}
    </MapboxProvider>
  );
};
